import { render, staticRenderFns } from "./KT-MapCard.vue?vue&type=template&id=0f2a4685&scoped=true&"
import script from "./KT-MapCard.vue?vue&type=script&lang=js&"
export * from "./KT-MapCard.vue?vue&type=script&lang=js&"
import style0 from "./KT-MapCard.vue?vue&type=style&index=0&id=0f2a4685&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2a4685",
  null
  
)

export default component.exports